import L from 'leaflet';
import moment from 'moment';

var needUpdateChart = true;

export default class PlaybackControl extends L.Control {
    constructor(playback, oid, hide, isShowPhotos, photosWindow) {
        super();
        this._clockCallback = this._clockCallback.bind(this);
        this.playback = playback;
        this.isHide = hide;
        this.playback.addCallback(this._clockCallback);
        this.photosWindow = photosWindow;
        this.oid = oid;

        let position = $('#bottompanel').height() + 20;

        this._html = `
            <div class="playback" id="playback_footer" class="ui-widget-content" style="bottom:${position}px;">         
                <div class="playback-play-botton-container" style="width: 57px;">
                    <span title="${messages['Previous']}" id="playback-previos" href="#" style="margin-right: 10px;">
                        <i class="fa fa-backward" style="color: #11a8d3;cursor:pointer"></i>
                    </span>
                    <span id="play-pause" title="${messages['Start']}" href="#" style="margin-right: 10px;">
                        <i id="play-pause-icon" class="fa fa-play" style="color: #11a8d3;cursor:pointer;width: 12px;"></i>
                    </span>
                    <span id="playback-next" title="${messages['Next']}" href="#" style="margin-right: 10px;">
                        <i class="fa fa-forward" style="color: #11a8d3;cursor:pointer"></i>
                    </span>
                </div> 
                <div class="playback-time-container">
                    <span id="time-label"></span>
                </div>
                <div class="playback-speed-container">
                    <span id="info-route-label"></span>
                </div>                
                <div>
                    <div id="time-slider"></div>
                </div>     
                <div class="playback-speed-data-container">
                    <a id="speed-btn">
                        <i class="icon-49" style="padding-right: 15px; color: #11a8d3; font-size: 38px;"></i> 
                        <span id="speed-icon-val" class="speed">1</span>
                        x
                    </a>
                </div>    
                <div class="speed-volume-container">
                    <div id="speed-slider"></div>
                </div>   
                <i
                    id="playback-close"
                    class="leaflet-popup-close-button"
                    href="#close"
                    style="outline: none;border: none;font: 30px/14px Tahoma, Verdana, sans-serif !important;cursor: pointer;position: absolute;right: 13px;top: 10px;color: #c3c3c3;"
                >×</i>
                ${isShowPhotos ? ' <img id="playback-photos" style="height: 30px;cursor:pointer" src="../../../Scripts/fort-map/images/camera.svg"/> ' : ''}
            </div>
        `;
        this._track = null;
    };

    setNeedUpdateChart(value) {
        needUpdateChart = value;
    };

    onAdd(map) {
        var html = this._html;
        $('#Map').after(html);
        this._setup();
        return L.DomUtil.create('div');
    };

    onRemove(map) {
        // Nothing to do here
    };

    _setup() {
        var self = this;
        var playback = this.playback;
        $('#play-pause').click(function () {
            if (playback.isPlaying() === false) {
                playback.start();
                $('#play-pause').prop('title', messages['Pause']);
                $('#play-pause-icon').removeClass('fa fa-play');
                $('#play-pause-icon').addClass('fa fa-pause');
            } else {
                playback.stop();
                $('#play-pause').prop('title', messages['Start']);
                $('#play-pause-icon').removeClass('fa fa-pause');
                $('#play-pause-icon').addClass('fa fa-play');
            }
        });

        $('#playback-next').click(() => self.moveTimeSlider(1));

        $('#playback-previos').click(() => self.moveTimeSlider(-1));

        $('#Map').append('<div id="playback-open-control"><i id="playback-open-control-icon" class="icon-arrow-right"></i></div>');

        $('#playback-close').click(() => {
            $('#playback_footer').addClass('hidden');
            $('#playback-open-control').removeClass('hidden');
            this.isHide = true;
        });

        $('#playback-open-control').click(() => {
            $('#playback_footer').removeClass('hidden');
            $('#playback-open-control').addClass('hidden');
            this.isHide = false;
        });

        $('#playback-photos').click(() => {
            let curTime = moment.unix(playback.getTime());

            let photo = this.photosWindow.photosMarkers[0];
            for (let element of this.photosWindow.photosMarkers) {
                if (curTime > moment(element.photoTime)) {
                    photo = element;
                }
                else
                    break;
            }

            this.photosWindow.fireEvent('setSrc', {
                oid: photo.oid,
                photoName: photo.photoName,
                photoTime: photo.photoTime,
                photoIndex: photo.photoIndex
            });

            this.photosWindow.show();
        });

        var startTime = playback.getTime();

        $('#time-label').html(L.Playback.Util.TimeStr(startTime));
        $('#info-route-label').html(playback.getInfoLabelText(startTime));

        $('#time-slider').slider({
            min: playback.getStartTime(),
            max: playback.getEndTime(),
            step: playback.getTickLen() / 1000,
            value: playback.getTime(),
            slide: (event, ui) => self.setTimeSlider(ui.value),
        });

        var maxSliderValue = 49;

        // maxPlaybackSliderValue задается в settings.js
        // доработка по задаче Малинко https://jira.fort.tel/browse/FM-818
        if (typeof maxPlaybackSliderValue !== 'undefined')
            maxSliderValue = maxPlaybackSliderValue;

        $('#speed-slider').slider({
            min: 1,
            max: maxSliderValue,
            step: 1,
            value: self._speedToSliderVal(this.playback.getSpeed()),
            slide: function (event, ui) {
                var speed = self._sliderValToSpeed(parseFloat(ui.value));

                playback.setSpeed(speed);
                $('.speed').html(speed).val(speed);
            }
        });

        $("#playback_footer").draggable();
        if (this.isHide) {
            $('#playback_footer').addClass('hidden');
        }
    };

    _clockCallback(ms, real, label_text) {
        $('#time-label').html(L.Playback.Util.TimeStr(real));
        $('#time-slider').slider('value', real);
        $('#info-route-label').html(label_text);

        let event = new CustomEvent('needCenterMap', { detail: { oid: this.oid, date: real } });
        document.dispatchEvent(event);

        event = new CustomEvent('playback:callback', { detail: { 'oid': this.oid, time: real } });
        document.dispatchEvent(event);
    };

    _speedToSliderVal(speed) {
        if (speed < 1) return -10 + speed * 10;
        return speed - 1;
    };

    _sliderValToSpeed(val) {
        if (val < 0) return parseFloat((1 + val / 10).toFixed(2));
        if (val == 1) {
            return 1;
        }
        return val + 1;
    };

    _combineDateAndTime(date, time) {
        var yr = date.getFullYear();
        var mo = date.getMonth();
        var dy = date.getDate();
        // the calendar uses hour and the timepicker uses hours...
        var hr = time.hours || time.hour;
        if (time.meridian === 'PM' && hr !== 12) hr += 12;
        var min = time.minutes || time.minute;
        var sec = time.seconds || time.second;
        return new Date(yr, mo, dy, hr, min, sec).getTime();
    };

    delete() {
        try {
            this.playback.stop();
            var element = document.getElementById("playback_footer");
            if (element != null)
                element.parentNode.removeChild(element);

            element = document.getElementById("playback-open-control");
            if (element != null)
                element.parentNode.removeChild(element);
        }
        catch (e) { }
    };

    moveTimeSlider = (delta) => {
        let playback = this.playback;
        if (playback.isPlaying()) {
            return;
        }

        let allTimes = playback._trackController._tracks[0]._times;
        let currentTime = playback.getTime();
        let currentTimeIndex = this.getNearestTimeIndex(allTimes, currentTime);
        let nextTimeIndex = currentTimeIndex + delta;
        while (nextTimeIndex > 0 && nextTimeIndex < allTimes.length - 1 && allTimes[nextTimeIndex] === allTimes[currentTimeIndex]) {
            nextTimeIndex += delta;
        }
        if (nextTimeIndex < 0) {
            nextTimeIndex = 0;
        }
        if (nextTimeIndex >= allTimes.length) {
            nextTimeIndex = allTimes.length - 1;
        }
        let nextTime = allTimes[nextTimeIndex];
        
        if (nextTime === currentTime) {
            return;
        }
        playback.setCursor(nextTime);
    };

    getNearestTimeIndex = (allTimes, time) => {
        let result = 0;
        let lastTimeIndex = allTimes.length - 1;
        while (result < lastTimeIndex && time > allTimes[result]) {
            result++;
        }
        if (time !== allTimes[result] && time > allTimes[0] && time < allTimes[lastTimeIndex]) {
            result--;
        }
        return result;
    };

    setTimeSlider = (time) => {
        let playback = this.playback;
        if (playback.isPlaying()) {
            return;
        }

        let allTimes = playback._trackController._tracks[0]._times;
        let currentTime = playback.getTime();
        let currentTimeIndex = this.getNearestTimeIndex(allTimes, currentTime);
        let newTimeIndex = this.getNearestTimeIndex(allTimes, time);

        if (currentTimeIndex === newTimeIndex) {
            return;
        }
        playback.setCursor(allTimes[newTimeIndex]);
    };
}
